import { useState } from "react";
import { Button, Flex } from "@mantine/core";
import { McInputNew } from "../../../components";
import { useAppDispatch } from "../../../hooks";
import { doCreateProject } from "../admin/restQueries";
import { setShowSuccessMessageThunk } from "../../../global/globalSlice";

export const AddProjectToMcApps = () => {
  const dispatch = useAppDispatch();
  const [projectNo, setProjectNo] = useState<number>();
  const [projectName, setProjectName] = useState<string>("");

  const save = async () => {
    const thisProject = await doCreateProject({ projectNo: projectNo, name: projectName });
    if (thisProject != null) {
      dispatch(setShowSuccessMessageThunk("Project added!"));
    }
  };

  return (
    <>
      <div>
        <div>Project number</div>
        <McInputNew
          style={{ width: "100%" }}
          type="number"
          value={projectNo}
          onChange={(e) => setProjectNo(Number(e.target.value))}
          name="text"
        />
        <div>Project name</div>
        <McInputNew
          style={{ width: "100%" }}
          type="text"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          name="text"
        />
        <Flex mt="sm" align="center">
          <Button disabled={projectNo === null || projectName === ""} color="green" onClick={save}>
            Save
          </Button>
        </Flex>
      </div>
    </>
  );
};
